module.exports = __webpack_public_path__ + "static/media/logo-bbva-w.0b2ae375.png";